<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-0(:title="$t('mantra')")

  section.u-mt-md
    .grid
      .column.is-widescreen-5.is-desktop-6
        .u-mb-mi
          AppImg(:srcset="[{ srcset: '{CDN_URL}/ventures/nasj@2x.webp 2x, {CDN_URL}/ventures/nasj.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/ventures/nasj@2x.png 2x, {CDN_URL}/ventures/nasj.png 1x', type: 'image/png' }]" ratio="3:2")
      .column.is-widescreen-5.is-desktop-6
        .content.u-mb-xs
          div(v-html="$t('content')")
        AppLink(to="https://www.behance.net/gallery/74759355/Nasj-Brand-Identity-Design" :title="$t('cta')" class="button-link  " v-html="$t('cta')")
        .u-mb-xs
        AppLink(to="https://www.behance.net/gallery/78669001/Nasj-UIUX-Design" :title="$t('cta2')" class="button-link  " v-html="$t('cta2')")


  .u-mb-md

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Nasj",
    "pageDesc":"Nasj is one of Baianat ventures and an online blogging platform that was built for designers, developers, strategists and techies.",
    "mantra":"Nasj arabic |blogging platform.",
    "content":"<p>Nasj is a blogging platform that we built for designers, developers, techies and strategies to help them express their thoughts in the field through writing and spread awareness in their communities.</p><p>It provides a blogging experience for arabs with a social flavor, with all free service and no subscription fees, Nasj provides the perfect space for creative writers to express their thoughts and feelings and with all the features they want. </p><p>The platform design was meant to be fun through unique illustrations that gives both writers and redaers a unique reading experience.</p><p>Nasj will be launched by late 2019, but you can check the brand and website design on Behance and leave us your comments.</p>",
    "cta":"Brand identity",
    "cta2":"UX/UI design"
  },
  "ar": {
    "pageTitle":"نسج",
    "pageDesc":"نسج هي واحدة من مشاريع بيانات ومنصة التدوين عبر الإنترنت التي تم تصميمها للمطورين والخبراء الاستراتيجيين والتقنيين والمصممين. ",
    "mantra":"منصة نسج |العربية للتدوين.",
    "content":"<p>نسج عبارة عن منصة تدوين صممناها من أجل المصممين والمطورين والتقنيين والاستراتيجيين لمساعدتهم على التعبير عن أفكارهم في مجالاتهم من خلال الكتابة ونشر الوعي في مجتمعاتهم.</p><p>إنها توفر تجربة تدوين للعرب ذات نكهة اجتماعية، مع كل الخدمات المجانية وبدون رسوم اشتراك، وتوفر نسج مساحة مثالية للكتاب المبدعين للتعبير عن أفكارهم ومشاعرهم وبكل المميزات التي يبحثون عنها.</p><p>تصميم المنصة يبدو ممتعًا من خلال الرسوم التوضيحية الفريدة التي توفر لكل من المؤلفين والمحللين تجربة قراءة فريدة من نوعها.</p><p>سيتم إطلاق خدمة نسج بحلول أواخر عام 2019 ، ولكن يمكنك التحقق من تصميم العلامة التجارية وموقع الويب على بيهانس وترك تعليقاتك.</p>",
    "cta":"تصميم العلامة التجارية",
    "cta2":"تصميم واجهة المستخدم / تجربة المستخدم"
  }
}
</i18n>
